<template>
    <div class="col-lg-12 mb-3" :class="{'chart-loading': loading}">
        <h3 class="mb-3"><b>Tổng Số Lượng Rủi Ro Theo Khu Vực Làm Việc</b></h3>
        <Chart type="bar" :data="basicData" :options="basicOptions" :key="componentKey"/>
    </div>
</template>

<script>
import Chart from '@/components/Chart.vue';
export default {
    name: "chartArea",
    props: {
        areas: Object,
        loading: Boolean
    },
    components: {
        Chart
    },
    watch: {
        "$props.areas"() {
            this.basicData.labels = this.areas?.dataChart?.label ?? [];
            this.basicData.datasets = this.areas?.dataChart?.datasets ?? [];
            this.componentKey++;
        }
    },
    data() {
        return {
            componentKey: 0,
            basicData: {
                // labels: ['Xưởng A', 'Xưởng B', 'Xưởng C', 'Xưởng D', 'Xưởng E', 'Xưởng F', 'Xưởng G'],
                maxBarThickness: 6,
                datasets: [
                    {
                        label: 'Cao',
                        backgroundColor: '#C00000',
                        pointStyle: 'rect',
                        // data: [3, 1, 4, 12, 3, 4, 5]
                    },
                    {
                        label: 'Trung bình',
                        backgroundColor: '#E97131',
                        pointStyle: 'rect',
                        // data: [1, 4, 1, 10, 1, 2, 1]
                    },
                    {
                        label: 'Thấp',
                        backgroundColor: '#3B7D22',
                        pointStyle: 'rect',
                        // data: [4, 6, 0, 2, 4, 5, 3]
                    },
                    {
                        label: 'Tổng',
                        backgroundColor: '#0F9ED4',
                        pointStyle: 'rect',
                        // data: [7, 11, 5, 24, 8, 11, 9]
                    }
                ]
            },
            basicOptions: {
                plugins: {
                    legend: {
                        labels: {
                            usePointStyle: true,
                            color: '#495057'
                        },
                        position: 'bottom'
                    },
                    datalabels: {
                        display: false
                    }
                }
            }
        }
    }
}
</script>